/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rights_Cap_Apps_Author_DescInputs */



/**
* | output |
* | --- |
* | "Allows authoring apps, dashboards and canvases." |
*
* @param {Rights_Cap_Apps_Author_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_cap_apps_author_desc = /** @type {((inputs?: Rights_Cap_Apps_Author_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Cap_Apps_Author_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Erlaubt das Erstellen von Apps, Dashboards und Canvases.")
	return /** @type {LocalizedString} */ ("Allows authoring apps, dashboards and canvases.")
});